import React from 'react'

import './quote.scss'


const Quote = ({ content }) => {
  const justifyQuote = content.justifyQuote.toLowerCase() === 'left' ? 'flex-start' : content.justifyQuote.toLowerCase() === 'center' ? 'center' : content.justifyQuote.toLowerCase() === 'right' ? 'flex-end' : 'flex-start'

  return (
    <div className="quote-container" style={{justifyContent: justifyQuote}} data-cy="quote">
      <div className="quote-wrapper">
        <div className="quote-body">
          <span className="quote-mark">&ldquo;</span><span>{content.quote.quote}</span><span className="quote-mark">&rdquo;</span>
        </div>
        <div className="quote-author">
          - {content.author}
        </div>
      </div>
    </div>
  )
}

export default Quote


// WEBPACK FOOTER //
// ./src/components/Quote/quote.js